import { Combobox, Transition } from '@headlessui/react'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import React, { FC, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { SearchResult } from '../../services/ProjectService'
import { getFileIcon } from '../table/ProjectContentsTable'
import { useNavigate, useParams } from 'react-router-dom'

type SearchComboboxProps = {
  options?: SearchResult[]
  search: string
  onSearch: any
}

const SearchCombobox: FC<SearchComboboxProps> = ({ options, search, onSearch }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { org } = useParams()

  const handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      navigate(`/${org}/search?query=${encodeURIComponent(search)}`)
    }
  }

  return (
    <Combobox value={search}>
      {({ open }) => (
        <div className='relative !w-[400px]'>
          <div className='relative  cursor-default rounded-md bg-white text-left'>
            <Combobox.Input
              onChange={(e) => onSearch(e.target.value)}
              displayValue={(value: any) => {
                return open ? '' : value
              }}
              placeholder={'Search'}
              className={`w-full border-gray-300 rounded-md py-2 text-gray-900 leading-5 ${
                open
                  ? 'ring-2 focus:ring-2 ring-sky-100 !border-sky-100 focus:border-sky-100 focus:ring-sky-100 pl-9 pr-3'
                  : 'pr-3 pl-9'
              }`}
              onKeyDown={handleEnterPress}
            />
            {/* )} */}
            <span className={`absolute inset-y-0 left-0 items-center pl-2 flex`}>
              <MagnifyingGlassIcon className='w-4 h-4 text-gray-400' />
            </span>
            {search && (
              <div className='absolute inset-y-0 inline-flex items-center text-center right-0 pr-3'>
                <button>
                  <XMarkIcon className='w-4 h-4 text-gray-600' onClick={() => onSearch('')} />
                </button>
              </div>
            )}
          </div>
          {search !== '' && (
            <Transition
              as={Fragment}
              leave='transition ease-in duration-100'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'
              afterLeave={() => onSearch('')}
            >
              <Combobox.Options className='absolute z-10 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm mt-1 top-full'>
                {options?.length === 0 && search !== '' ? (
                  <div className='relative cursor-default select-none py-2 px-4 text-gray-700'>{t('nothingFound')}</div>
                ) : (
                  options?.map((option, index) => (
                    <Combobox.Option
                      key={`option-${index}`}
                      value={option}
                      className='w-full cursor-pointer py-2 px-4 hover:bg-slate-100'
                      onClick={() => {
                        // console.log('clicked')
                        navigate(
                          `/${org}${option.path.replace(/studio/, '').trim()}/${
                            option.name.includes('.')
                              ? `modeler/${option.name.split('.')[1]}/${option.name}`
                              : option.name
                          }`,
                        )
                      }}
                    >
                      <div className='flex items-center'>
                        {getFileIcon(option.name, 'w-6 h-6 mr-2')}
                        <div className='flex flex-col'>
                          <p className='font-sans font-normal text-sm leading-[22px] tracking-[-0.03em] align-middle'>
                            {' '}
                            {option.name}
                          </p>
                          <p className='font-sans font-normal text-xs leading-[18px] tracking-[-0.03em] align-middle text-[#7583A6]'>
                            {' '}
                            {option.path}
                          </p>
                        </div>
                      </div>
                    </Combobox.Option>
                  ))
                )}
              </Combobox.Options>
            </Transition>
          )}
        </div>
      )}
    </Combobox>
  )
}

export default SearchCombobox
